import { render } from '../../App'

import Fepo from './Fepo'

import { reducer } from './reducer'

render(Fepo, reducer)




